import { Builder, withChildren } from '@builder.io/react';
import Slider from './slider';
import theme from '../../gatsby-plugin-theme-ui';

const defaultSlide = {
  '@type': '@builder.io/sdk:Element',
  component: {
    name: 'Block',
    options: {
      padding: 'medium',
      backgroundColor: 'white',
    },
  },
};

Builder.registerComponent(withChildren(Slider), {
  name: 'Slider',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'string',
      enum: Object.keys(theme.colors),
      defaultValue: 'blue30',
    },
    {
      name: 'backgroundColorOverride',
      type: 'color',
      advanced: true,
      required: false,
    },
    {
      name: 'sectionSize',
      type: 'string',
      enum: [...Object.keys(theme.space), 'viewHeight100'],
      defaultValue: 'large',
    },
    {
      name: 'slidesToShow',
      type: 'number',
      defaultValue: 1,
      required: true,
      advanced: true,
    },
    {
      name: 'slidesToScroll',
      type: 'number',
      defaultValue: 1,
      required: true,
      advanced: true,
    },
    {
      name: 'showDots',
      type: 'boolean',
      defaultValue: true,
      required: false,
    },
    {
      name: 'infinite',
      type: 'boolean',
      defaultValue: true,
      required: false,
    },
    {
      name: 'showArrows',
      type: 'boolean',
      defaultValue: true,
      required: false,
    }
  ],
  childRequirements: {
    message: 'You can only put Blocks in Sliders',
    query: {
      'component.name': { $in: ['Block'] },
    },
  },
  defaultChildren: [defaultSlide, defaultSlide],
});
